import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPromptSuggestion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPromptSuggestion"><Path d="M6.4 2H5.6L4.6 4.6L2 5.6V6.4L4.6 7.4L5.6 10H6.4L7.4 7.4L10 6.4V5.6L7.4 4.6L6.4 2Z" fill="currentColor"/><Path d="M18.2197 12.2803L10 20.5L4.84863 21.1514L5.5 16L13.7197 7.78027L18.2197 12.2803Z" fill="currentColor"/><Path d="M23 7.5L19.2803 11.2197L14.7803 6.71973L18.5 3L23 7.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPromptSuggestion;
